import "./Contact.css";
import linkedin from "../../images/linkedin.svg";
import github from "../../images/github.svg";
import cv from "../../images/cv.svg";
import notion from "../../images/notion.svg";

const Contact = () => {
  return (
    <div className="contact">
      <h1>Contacts and work</h1>
      <a
        href="https://www.linkedin.com/in/andreisenyuva/"
        target="_blank"
        alt="linkedin"
        rel="noreferrer">
        <img src={linkedin} alt="linkedin" width={60} />
      </a>
      <a
        href="https://www.github.com/hurxan/"
        target="_blank"
        alt="github"
        rel="noreferrer">
        <img src={github} alt="github" width={60} />
      </a>
      <a
        href="https://www.notion.so/@hurxan"
        target="_blank"
        alt="notion"
        style={{ filter: "invert(100%)" }}
        rel="noreferrer">
        <img src={notion} alt="notion" width={55} />
      </a>

      <p>
        Resume/CV
      </p>
      <a
        href="./CV_Senyuva.pdf"
        target="_blank"
        alt="resume"
        style={{ filter: "invert(100%)" }}
        rel="noreferrer">
        <img src={cv} alt="github" width={60} />
      </a>

      <p>
        You can reach me via my{" "}
        <a href="mailto:senyuva.andrei@gmail.com">email</a>.
      </p>
    </div>
  );
};

export default Contact;
